import { ApiServiceCenter } from "@/api/service-center";
import { useLocalizedQuery } from "@/hooks/locale/useLocalizeQuery/useLocalizeQuery";

export const useServiceCenterPageData = () => {
  const { data: serviceCenterPage, isLoading: serviceCenterPageLoading } = useLocalizedQuery({
    queryKey: ["serviceCenterPage"],
    queryFn: async lang => ApiServiceCenter.getServiceCenterPage(lang),
  });

  return {
    serviceCenterPage: {
      serviceCenterPage,
      loading: serviceCenterPageLoading,
    },
  };
};
